import { useFormContext } from 'react-hook-form';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LwFormInput } from 'redesign';
import { HqUserRoleMatrix } from './user-role-matrix';
import { HqUserFormContext } from './user-create';
import { RoleMatrix } from '../../../../services/userService';

interface UserFormProps {
  state?: 'update' | 'create';
  roleMatrix: RoleMatrix[];
}

export const UserForm = ({ state, roleMatrix }: UserFormProps) => {
  const { control } = useFormContext<HqUserFormContext>();
  const { t } = useTranslation('hq-screen-specific');

  return (
    <form>
      <Grid container item xs={6} spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h3" my={1}>
            {t('users.form.personal_info_title')}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <LwFormInput
            name="firstName"
            label={t('users.form.first_name_label')}
            control={control}
            rules={{ required: t('users.form.first_name_required') }}
          />
        </Grid>
        <Grid item xs={12}>
          <LwFormInput
            name="lastName"
            label={t('users.form.last_name_label')}
            control={control}
            rules={{ required: t('users.form.last_name_required') }}
          />
        </Grid>
        <Grid item xs={12}>
          <LwFormInput
            name="nickname"
            label={t('users.form.nickname_label')}
            control={control}
            rules={{ required: t('users.form.nickname_required') }}
          />
        </Grid>
        <Grid item xs={12}>
          <LwFormInput
            name="email"
            label={t('users.form.email_label')}
            inputType="email"
            control={control}
            rules={{ required: t('users.form.email_required') }}
            disabled={state === 'update'}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h3" my={2}>
            {t('users.form.roles_title')}
          </Typography>
          <HqUserRoleMatrix roleMatrix={roleMatrix} disabled={false} />
        </Grid>
      </Grid>
    </form>
  );
};
